import { type ProductType, type Prompt } from "@1js/pl-card-components";
import {
  createDOMRenderer,
  FluentProvider,
  Portal,
  RendererProvider,
} from "@fluentui/react-components";
import React from "react";
import { Loader } from "./Loader.web";
import { type LoaderStateType } from "./Loader.web.hook";

interface HandoffLoadingWindowProps {
  windowRef: Window;
  onCancel: () => void;
  onCopy: () => void;
  destination: ProductType | string;
  state: LoaderStateType;
  prompt: Prompt;
}

export default function HandoffLoadingWindow(props: HandoffLoadingWindowProps) {
  const { windowRef } = props;
  const renderer = React.useMemo(
    () => createDOMRenderer(windowRef.document),
    [windowRef.document]
  );

  return (
    <Portal mountNode={windowRef.document.body}>
      <RendererProvider renderer={renderer} targetDocument={windowRef.document}>
        <FluentProvider targetDocument={windowRef.document}>
          <Loader
            onCancel={props.onCancel}
            onCopy={props.onCopy}
            destination={props.destination}
            state={props.state}
            prompt={props.prompt}
          />
        </FluentProvider>
      </RendererProvider>
    </Portal>
  );
}
